import { IPublicContactResourceshort } from '../../props/users/contact';
import Request from './../request';

const ContactService = {
  retrieve: async (qs?: string): Promise<IPublicContactResourceshort[]> => {
    try {
      const results = await Request.get(`/api/contacts?${qs || ''}`);
      return results;
    } catch (e) {
      throw e;
    }
  },
  get: async (id: string): Promise<IPublicContactResourceshort> => {
    try {
      const results = await Request.get(`/api/contacts/${id}`);
      return results;
    } catch (e) {
      throw e;
    }
  },
  new: async (data: FormData): Promise<IPublicContactResourceshort> => {
    try {
      const result = await Request.post(`/api/contacts`, data, 'multipart/form-data');
      return result;
    } catch (e) {
      throw e;
    }
  },
  update: async (id: string, data: FormData): Promise<IPublicContactResourceshort> => {
    try {
      const result = await Request.post(`/api/contacts/${id}?_method=PUT`, data, 'multipart/form-data');
      return result;
    } catch (e) {
      throw e;
    }
  },
  delete: async (id: string): Promise<void> => {
    try {
      await Request.delete(`/api/contacts/${id}`);
      return;
    } catch (e) {
      throw e;
    }
  },
};

export default ContactService;
